import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import NewArticleStore from "./NewArticleStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import SellerNameInput from "../../Inputs/SellerNameInput/SellerNameInput";
import {useStyles} from "./NewArticleButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ArticleDescriptionInput from '../../Inputs/ArticleDescriptionInput/ArticleDescriptionInput';
import Icon from '../../../ui_components/Icon/Icon';
import IconName from '../../../ui_components/Icon/enums/IconName';
import NewArticleButtonProperties from './NewArticleButtonProperties';
import Currency from '../../../entities/Currency';
import PriceInput from '../../Inputs/PriceInput/PricetInput';
import CurrencySelect from '../../Selects/CurrencySelect/CurrencySelect';
import { useUserContext } from '../../../contexts/UserContext';
import ArticleCategorySelect from '../../Selects/ArticleCategorySelect/ArticleCategorySelect';
import ArticleCategory from '../../../entities/productOrder/article/ArticleCategory';
import ArticleStatusSelect from '../../Selects/ArticleStatusSelect/ArticleStatusSelect';
import ArticleStatus from '../../../entities/ArticleStatus';
import TextInput from '../../../ui_components/TextInput/TextInput';


const NewArticleButton: React.FC<NewArticleButtonProperties> = ({
                                                                  onClick = () => {
                                                                  },
                                                                  onSave = () => {
                                                                  },
                                                                  showIcon = true,
                                                                  showText = true,
                                                                  disabled,
                                                                  className = '',
                                                                  articleId,
                                                                  rounded = false,
                                                                  size = ButtonSize.DEFAULT,
                                                                  type = ButtonType.DEFAULT
                                                              }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    const store = new NewArticleStore(commonContext, articleId);

    if (!userStore.isRootAgency()) {
        return <></>;
    }

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    const onNameChange = (newName: string) => store.article.name = newName;
    const onSkuChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        store.article.sku = event.target.value;
    }
    const onCategoryChange = (newCategory?: ArticleCategory) => store.article.categoryId = newCategory?.id;
    const onStatusChange = (newStatus: ArticleStatus) => store.article.status = newStatus;
    const onDescriptionChange = (newDescription: string) => store.article.description = newDescription;
    const onPurchasePriceChange = (newPurchasePrice: number) => store.article.purchasePrice = newPurchasePrice;
    const onConfectionPriceChange = (newConfectionPrice: number) => store.article.confectionPrice = newConfectionPrice;
    const onConfectionPriceCurrencyChange = (newConfectionPriceCurrency: Currency) => store.article.confectionPriceCurrency = newConfectionPriceCurrency;
    
    const onArticleSave = async () => {
        if (!store.enableButton) {
            return;
        }
        const saved = await store.save();
        if (saved) {
            store.closeModal();
            if (onSave) {
                onSave();
            }
        }
    }

    const text = i18n.translate((store.isEditing ? "EDIT_ARTICLE" : "NEW_ARTICLE"));
    const btnIcon = store.isEditing ? <Icon name={IconName.EDIT_ICON}/> : <Icon name={IconName.CREATE_ICON}/>;
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text}
                    onClose={onCloseModal}
                    open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <SellerNameInput
                            error={i18n.translate(store.nameError)}
                            fullWidth autoFocus className={classes.input}
                            value={store.article?.name}
                            onChange={onNameChange}/>
                        <TextInput
                            label={'SKU'}
                            error={i18n.translate(store.skuError)}
                            fullWidth autoFocus className={classes.input}
                            value={store.article?.sku}
                            onChange={onSkuChange}/>
                        <ArticleCategorySelect className={classes.category_select}
                            selected={store.article?.categoryId ? new ArticleCategory(store.article?.categoryId, store.article?.categoryName ?? '', '', '') : undefined}
                            fullWidth onChange={onCategoryChange}/>
                        {store.isEditing &&
                        <ArticleStatusSelect className={classes.input}
                            selected={store.article?.status}
                            fullWidth onChange={onStatusChange}/>}
                        <div className={classes.price_container}>
                            <PriceInput label={'Precio de confección'} fullWidth className={classes.input}
                                value={store.article?.confectionPrice}
                                onChange={onConfectionPriceChange}/>
                            <CurrencySelect fullWidth className={classes.input}
                                selected={store.article?.confectionPriceCurrency}
                                onChange={onConfectionPriceCurrencyChange}/>
                        </div>
                        <PriceInput label={'Precio de compra'} fullWidth className={classes.input}
                                value={store.article?.purchasePrice}
                                onChange={onPurchasePriceChange}/>
                        <ArticleDescriptionInput fullWidth className={classes.input}
                                    value={store.article?.description}
                                    onChange={onDescriptionChange}/>
                        <Button
                            disabled={!store.enableButton}
                            loading={store.loading} className={classes.input} onClick={onArticleSave}
                            type={ButtonType.SECONDARY}
                            text={i18n.translate("SAVE")}/>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default NewArticleButton;
